module.exports = __webpack_public_path__ + "img/logo11.e62c312.jpg";